import {
    Utilities,
    ViewViewModel,
    LocatorHelper,
    LabelViewModel,
    ImageViewModel,
    ButtonViewModel,
    WindowViewModel,
    TextBoxViewModel,
    MLStringPopupBoxViewModel,
    MultilineTextBoxViewModel,
    GlobalConfiguration,
    NavigationService,
} from 'radpresentation.htmlclient.defaultviewextensions';
class CreatePropertyGroupViewViewModel extends ViewViewModel {
    // html bindings
    public okay: ButtonViewModel;
    public cancel: ButtonViewModel;
    private window: WindowViewModel;
    private groupNameLabel: LabelViewModel;
    private groupName: TextBoxViewModel;
    private groupErgNameLabel: LabelViewModel;
    private groupErgName: MLStringPopupBoxViewModel;

    // by params
    private takenNames: Array<string>;
    private readonly callback: (
        newGroupName: string,
        newGroupMlString: { [key: string]: string }
    ) => void;

    constructor(params: any) {
        super(params);

        this.callback = params.callback;
        this.takenNames = (params.takenNames || []).map((anyName: string) =>
            anyName.toUpperCase()
        );
        this.viewFactory = params.viewFactory;

        this.createWindow();
        this.createOkayButton();
        this.createCancelButton();

        this.groupNameLabel = LabelViewModel.create(
            'RADEM.RADEXTENSIONMANAGER.PROPERTYGROUP_NAME'
        );
        this.groupName = new TextBoxViewModel({
            locator: LocatorHelper.buildLocator(this.locator, 'name_input'),
        });

        this.groupErgNameLabel = LabelViewModel.create(
            'RADEM.RADEXTENSIONMANAGER.PROPERTYGROUP_ERG_NAME'
        );
        this.groupErgName = new MLStringPopupBoxViewModel({
            isMultiline: false,
            useIsEachLanguageEqual: true,
            isEachLanguageEqual: true,
            locator: this.locator,
            multilineTextBox: new MultilineTextBoxViewModel({
                locator: LocatorHelper.buildLocator(this.locator, 'Value'),
                value: this.observableOrDefault(''),
                isMultiline: false,
            }),
        });

        this.defineComputed(() => {
            const groupName = this.groupName.value();
            const groupErgName = this.groupErgName.value();

            this.okay.isEnabled(
                Utilities.isNotBlank(groupName) &&
                    Utilities.isNotBlank(groupErgName) &&
                    !_.contains(this.takenNames, groupName.toUpperCase())
            );
        });
    }

    private createWindow() {
        this.window = new WindowViewModel({
            locator: LocatorHelper.buildLocator(
                this.locator,
                'create_prop_group',
                'window'
            ),
            isOpen: true,
            width: 600,
            isModal: true,
            allowClose: false,
            headline: LabelViewModel.create(
                'RADEM.RADEXTENSIONMANAGER.CREATE_PROPERTY_GROUP'
            ),
            onClose: () => {
                NavigationService.getInstance().removeViewFactoryIsolated(
                    this.viewFactory
                );
            },
        });
    }

    private createOkayButton() {
        this.okay = new ButtonViewModel({
            locator: LocatorHelper.buildLocator(this.locator, 'button.okay'),
            image: new ImageViewModel({
                locator: 'button.okay.image',
                source: GlobalConfiguration.inlineImages.WINDOW_OK,
                alternativeText: new LabelViewModel({
                    ergName: 'OKAY',
                }),
            }),
            label: new LabelViewModel({
                locator: 'button.okay.label',
                ergName: 'OKAY',
            }),
            onClick: () => {
                this.callback(
                    this.groupName.value(),
                    this.groupErgName.getPlainValues()
                );
                this.window.isOpen(false);
            },
            isEnabled: false,
        });
    }

    private createCancelButton() {
        this.cancel = new ButtonViewModel({
            locator: LocatorHelper.buildLocator(this.locator, 'button.cancel'),
            image: new ImageViewModel({
                locator: 'button.cancel.image',
                source: GlobalConfiguration.inlineImages.WINDOW_CANCEL,
                alternativeText: new LabelViewModel({
                    ergName: 'CANCEL',
                }),
            }),
            label: new LabelViewModel({
                locator: 'button.cancel.label',
                ergName: 'CANCEL',
            }),
            onClick: () => {
                this.window.isOpen(false);
            },
        });
    }
}

export default CreatePropertyGroupViewViewModel;
